export enum NOTIFICATIONS_PLATFORM_FILTER_ENUM {
  ALL = "ALL",
  UNREAD = "UNREAD",
  PLATFORM = "PLATFORM",
  COMPANY = "COMPANY",
  MY_SPACE = "MY_SPACE",
}

export enum NOTIFICATIONS_PLATFORM_ENUM {
  MY_SPACE = "MY_SPACE",
  COMPANY = "COMPANY",
  PLATFORM = "PLATFORM",
}
